import * as React from 'react';
import { Menu, Transition } from '@headlessui/react';
import {
  ChevronDownIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/20/solid';

import clsx from 'clsx';
import { Fragment, useState } from 'react';

// const options = [
//   { label: 'All Articles2', value: 'all' },
//   { label: 'Reviews', value: 'reviews' },
//   { label: 'Guides', value: 'guides' },
//   { label: 'Features', value: 'features' },
//   { label: 'News', value: 'news' },
// ];

function NewCarPriceListsSearchBar({onChange, onSubmit, searchValue}) {
  // const [value, setValue] = useState('');
  const [query, setQuery] = useState('');
  const defaultOnChange = (e) => {
    setQuery(e.target.value);
  }
  
  return (
    <div className="border-b border-stroke-boundary py-4 fixed top-[117px] sm:top-[100px] left-0 right-0 z-40 bg-white">
      <div className="flex flex-col lg:flex-row justify-between gap-y-4 gap-x-7 items-center max-w-[1440px] mx-auto px-3 sm:px-8 xl:px-16">
        <div className="relative rounded flex-1 w-full">
          {/* <div className="absolute inset-y-0 left-0 flex items-center">
            <CategoriesDropdown value={value} onSelect={setValue} />
          </div> */}
          <input
            type="text"
            name="phone-number"
            id="phone-number"
            className="block w-full rounded border-0 py-2 pl-4 text-gray-900 ring-1 ring-inset ring-stroke-input placeholder:text-gray-400 focus:outline-none"
            placeholder="Search Brand or Authorised Distributor..."
            onChange={onChange || defaultOnChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onSubmit && onSubmit(searchValue || query);
              }
            }}
            value={searchValue || query}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-3 flex items-center"
            onClick={(e) => {
              onSubmit && onSubmit(searchValue || query);
            }}
          >
            <MagnifyingGlassIcon className="w-5 h-5 text-content-subdued" />
          </button>
        </div>
        {/* <div className="w-full flex gap-x-1 lg:gap-x-4 items-center text-content-primary justify-stretch w-full lg:w-fit overflow-auto">
          {options.map((item, index) => (
            <button
              type="button"
              key={index}
              onClick={() => setValue(item.value)}
              className={clsx(
                value === item.value
                  ? 'bg-category-active border-os-border'
                  : 'border-white',
                'px-3 lg:px-4 py-1 sm:py-2 lg:py-1.5 text-sm lg:text-base rounded-3xl border whitespace-nowrap w-full lg:w-auto',
              )}
            >
              {item.label}
            </button>
          ))}
        </div> */}
      </div>
    </div>
  );
}

export default NewCarPriceListsSearchBar;

function CategoriesDropdown({ value, onSelect }) {
  return (
    <Menu as="div" className="h-full relative inline-block text-left">
      <Menu.Button className="h-full rounded-bl rounded-tl border-r border-stroke-input bg-transparent py-0 px-3 focus:outline-none flex items-center justify-between w-32 text-content-subdued text-base">
        {options.find((item) => item.value === value)?.label}
        <ChevronDownIcon
          className="-mr-1 h-5 w-5 text-stroke-input"
          aria-hidden="true"
        />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-right bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {options.map((item, index) => (
              <Menu.Item key={index} onClick={() => onSelect(item.value)}>
                {({ active }) => (
                  <span
                    className={clsx(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm',
                    )}
                  >
                    {item.label}
                  </span>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
